import StickyJs from '../../components/sticky'
import QuoteForm, {Modality} from '../../components/quote-form'

const init = () => {
  StickyJs()
  QuoteForm()
  Modality()
}

export default init
